export const REPLACE_HIGHLIGHTS_DATA_EVENT = 'REPLACE_HIGHLIGHTS_DATA_EVENT';
export const REPLACE_ZONES_THRESHOLD = 'REPLACE_ZONES_THRESHOLD';
export const REPLACE_PLAYERS_DATA_EVENT = 'REPLACE_PLAYERS_DATA_EVENT';
export const REPLACE_PLAYERS_SESSIONS_DATA_EVENT = 'REPLACE_PLAYERS_SESSIONS_DATA_EVENT';
export const REPLACE_MODAL_PLAYER_DATA = 'REPLACE_MODAL_PLAYER_DATA';
export const REPLACE_BALL_METRICS_MODAL_PLAYER_DATA = 'BALL_METRICS_REPLACE_MODAL_PLAYER_DATA';
export const REPLACE_MANAGE_DATA_EVENT = 'REPLACE_MANAGE_DATA_EVENT';
export const PATCH_MANAGE_DATA_EVENT = 'PATCH_MANAGE_DATA_EVENT';
export const SET_EDITABLE_MANAGER = 'SET_EDITABLE_MANAGER';

export const REPLACE_PLAYERS_BALL_METRICS_DATA_EVENT = 'REPLACE_PLAYERS_BALL_METRICS_DATA_EVENT';
export const REPLACE_PLAYERS_BALL_METRICS_DATA_BY_ZONE_EVENT = 'REPLACE_PLAYERS_BALL_METRICS_DATA_BY_ZONE_EVENT';

export const REPLACE_VELOCITY_GRAPH_DATA = 'REPLACE_VELOCITY_GRAPH_DATA';

export const UPDATE_META_DATA_EVENT = 'UPDATE_META_DATA_EVENT';
export const UPDATE_HIGHLIGHTS_DATA_EVENT = 'UPDATE_HIGHLIGHTS_DATA_EVENT';
export const ADD_PLAYERS_DATA_EVENT = 'ADD_PLAYERS_DATA_EVENT';
export const UPDATE_LIVE_ALERTS_EVENT = 'UPDATE_LIVE_ALERTS_EVENT';

export const CHANGE_TO_LIVE_PRACTICE = 'CHANGE_TO_LIVE_PRACTICE';

export const UPDATE_PRACTICE_START_TIME = 'UPDATE_PRACTICE_START_TIME';

export const GET_PLAYER_BLINKS = 'GET_PLAYER_BLINKS';
export const GET_PLAYERS_DATA = 'GET_PLAYERS_DATA';
export const ARE_TRACKS_FETCHING = 'ARE_TRACKS_FETCHING';

export const NO_DATA_FOUNDED = 'NO_DATA_FOUNDED';
export const CLEAR_PRACTICE_DATA = 'CLEAR_PRACTICE_DATA';
export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE';
export const CLEAR_PLAYERS_TRACKS_DATA = 'CLEAR_PLAYERS_TRACKS_DATA';
export const CLEAR_TRACKS_DATA_ON_UNMOUNT = 'CLEAR_TRACKS_DATA_ON_UNMOUNT';

export const GET_TEAM_FIELDS = 'GET_TEAM_FIELDS';
export const FETCHED_DATA_FAILED = 'FETCHED_DATA_FAILED';
export const MAP_SHOULD_MOUNT = 'MAP_SHOULD_MOUNT';
export const SET_FIELD_IMAGE = 'SET_FIELD_IMAGE';

export const GET_PLAYERS_METRICS = 'GET_PLAYERS_METRICS';
export const SET_METRIC_CURRENT_SEC = 'SET_METRIC_CURRENT_SEC';

export const UPDATE_PRACTICES_DATA_EVENTS = 'UPDATE_PRACTICES_DATA_EVENTS';
